import { useParams } from 'react-router-dom';
import { tenantBasePath } from '../../lib/tenant.js';
import { useTenantSettings } from '../../lib/tenantSettings.js';
import { amountUnitLabel } from '../../lib/finance-display.js';
import { OpenItemsSalesReturnsTab } from '../finance/OpenItemsSalesReturnsTab.js';

/**
 * CRM / Sales Returns page.
 * Provides sales operations access to view, track, and issue sales returns.
 */
export function SalesReturnsPage() {
  const { slug } = useParams<{ slug: string }>();
  const { amountDisplayUnit } = useTenantSettings();
  const unit = amountDisplayUnit;
  const unitLabel = amountUnitLabel(unit);

  if (!slug) return null;
  const base = tenantBasePath(slug);

  return (
    <div style={{ padding: 16 }}>
      <OpenItemsSalesReturnsTab slug={slug} base={base} unit={unit} unitLabel={unitLabel} />
    </div>
  );
}
